import React, { Component } from 'react';
import ReproduceInvoiceModal from './ReproduceInvoiceModal';

class GroupedInvoiceList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showReproduceInvoiceModalInvoice: false,
        };
    }

    showReproduceInvoiceModal = (_, invoice) => {
        this.setState({
            showReproduceInvoiceModalInvoice: invoice,
        });
    };

    hideReproduceInvoiceModal = () => {
        this.setState({
            showReproduceInvoiceModalInvoice: false,
        });
    };

    render() {
        let invoices = this.props.invoices.map((invoice, index) => {
            return (
                <tr key={index}>
                    <td>{invoice.invoice_identifier}</td>
                    <td>{invoice.invoice_group?.name}</td>
                    <td>{moment(invoice.date_from).format('DD/MM/YYYY')}</td>
                    <td>
                        <a
                            href={this.props.downloadUrl.replace('invoice:id', invoice.id) + '?type=pdf'}
                            className="d-block"
                        >
                            {invoice.date_from + invoice.invoice_group.name + '.pdf'}
                        </a>
                    </td>
                    <td>
                        <a
                            href={this.props.downloadUrl.replace('invoice:id', invoice.id) + '?type=xlsx'}
                            className="d-block"
                        >
                            {invoice.date_from + invoice.invoice_group.name + '.xlsx'}
                        </a>
                    </td>
                    <td>
                        <div className="d-flex">
                            <input
                                type="text"
                                name="po_number"
                                className="form-control"
                                value={invoice.po_number || ''}
                                placeholder="PO NUMBER"
                                onChange={(e) => this.props.onPoChange(e, invoice.invoice_identifier)}
                            />
                            <button
                                className="btn btn-cw-primary"
                                onClick={() => this.props.savePoNumber(invoice.invoice_identifier)}
                            >
                                {this.props.loading === invoice.invoice_identifier ? (
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                ) : (
                                    'Save'
                                )}
                            </button>
                        </div>
                    </td>
                    <td>
                        <button
                            style={{
                                padding: 0,
                                marginBottom: 0,
                                marginRight: '4px',
                                border: 0,
                            }}
                            onClick={(e) => this.showReproduceInvoiceModal(e, invoice)}
                            className="btn btn-link text-danger"
                            title="Reproduce Invoice"
                        >
                            <i className="fas fa-recycle mr-12"></i>
                        </button>
                    </td>
                </tr>
            );
        });
        return (
            <>
            <table className="table transform-text">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Group name</th>
                        <th>Created</th>
                        <th>Download pdf</th>
                        <th>Download spreadsheet</th>
                        <th className="text-center">Add PO Number</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>{invoices}</tbody>
            </table>
            {this.state.showReproduceInvoiceModalInvoice && (
                <ReproduceInvoiceModal
                    show={true}
                    onHide={this.hideReproduceInvoiceModal}
                    invoice={this.state.showReproduceInvoiceModalInvoice}
                />
            )}
            </>
        );
    }
}

export default GroupedInvoiceList;
